import ReactGA from 'react-ga4';
import { GOOGLE_ANALYTICS_ID } from '../config/constants';

ReactGA.initialize(GOOGLE_ANALYTICS_ID);

export const trackPage = (page: string, options: any = {}): void => {
  ReactGA.set({ page, ...options });
  ReactGA.send({ hitType: 'pageview', page });
};
